// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"958561d4","96":"50036559","133":"41b78f6d","568":"0923bdca","917":"7729e52b"}[chunkId] + ".chunk.js";
};